import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=b6449d9a&scoped=true&"
import script from "./productInfo.vue?vue&type=script&lang=js&"
export * from "./productInfo.vue?vue&type=script&lang=js&"
import style0 from "../pc.css?vue&type=style&index=0&id=b6449d9a&scoped=true&lang=css&"
import style1 from "../phone.css?vue&type=style&index=1&id=b6449d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6449d9a",
  null
  
)

export default component.exports